<div class="d-flex mt-1">
    <form-component-label [batchUpdateMode]="false"
                          [config]="labelConfig"
                          [included]="false">
    </form-component-label>
    <div class="d-flex w-100">
        <div class="d-flex flex-column w-100">
            <div class="d-flex flex-row w-100">
                <div class="d-flex flex-column w-100" #currentFormField>
                    <lumi-select [options]="objectTypeOptions"
                                 [multi]="true"
                                 [selectedOptions]="objectTypeOptionsSelected"
                                 [showOptionFilter]="objectTypeOptions?.length > 10"
                                 [sortSelection]="false"
                                 (onOptionsSelect)="onOptionsSelect($event)">
                    </lumi-select>
                </div>
            </div>
        </div>
    </div>
</div>
